import { endOfMonth, endOfYear, startOfMonth, startOfYear, subDays } from "date-fns";
import { UserModel } from "../app/modules/auth/models/UserModel";
import { SettingMultiMeetings } from "../interfaces/Settings";
import { CustomeStoreCompanyIdProps } from "../stores/CustomeStore";


export const getStartDate = (user: UserModel, companyId: CustomeStoreCompanyIdProps, selectMultiMeeting: SettingMultiMeetings): Date => {
    const today = new Date();

    if (selectMultiMeeting.defaultFromDate) return new Date(selectMultiMeeting.defaultFromDate)
    else if (user.data.company_id === companyId.hom) return startOfMonth(today)
    else return startOfMonth(today)
}

export const getEndDate = (user: UserModel, companyId: CustomeStoreCompanyIdProps, selectMultiMeeting: SettingMultiMeetings): Date => {
    const today = new Date();

    if (selectMultiMeeting.defaultToDate) return new Date(selectMultiMeeting.defaultToDate)
    else if (user.data.company_id === companyId.hom) return endOfMonth(today)
    else return endOfMonth(today)
}

export const getTypeDate = (selectMultiMeeting: SettingMultiMeetings): string => {
    const typeDateMap: Record<string, string> = {
        NONE: 'CREATED',
        CREATED: 'CREATED',
        STARTED: 'STARTED',
        ENDED: 'ENDED',
    };

    if (selectMultiMeeting.sourceFilterDate) return typeDateMap[selectMultiMeeting.sourceFilterDate]
    else return "1"
}